var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 120 120",
    id: "Layer_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFC54D;}\r\n\t.st1{fill:#7A9FFF;}\r\n\t.st2{fill:#EDB248;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.5,101.6h-5.3v-2c0-0.8-0.6-1.4-1.4-1.4H65l-1-7.3h2.2c0.8,0,1.4-0.6,1.4-1.4s-0.6-1.4-1.4-1.4h-2.6    l-0.3-2h-6.9l-0.3,2h-2.6c-0.8,0-1.4,0.6-1.4,1.4s0.6,1.4,1.4,1.4h2.2l-1,7.3h-2.8c-0.8,0-1.4,0.6-1.4,1.4v2h-5.3    c-2,0-3.6,1.6-3.6,3.6v4.5H78v-4.5C78.1,103.2,76.5,101.6,74.5,101.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M75.7,30.1v6h25V51c-1.4,2.6-8.5,14-29,11.5l-0.7,6c2.3,0.3,4.5,0.4,6.6,0.4c22,0,28.7-15.3,29-16l0.2-0.6    V30.1H75.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.9,68.4l-0.7-6c-20.5,2.6-27.7-8.9-29-11.5V36.1h25v-6h-31v22.2l0.2,0.6c0.3,0.7,7,16,29,16    C44.4,68.8,46.6,68.7,48.9,68.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "81.3,30.1 81.3,93.1 88.4,87.1 95.5,93.1 95.5,30.1   "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "24.4,93.1 31.5,87.1 38.6,93.1 38.6,30.1 24.4,30.1   "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60,89.3L60,89.3c-16.4,0-29.7-13.3-29.7-29.7v-40h59.3v40C89.6,76,76.3,89.3,60,89.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.6,36.5l3.8,7.6c0.1,0.2,0.3,0.4,0.6,0.4l8.4,1.2c0.6,0.1,0.8,0.8,0.4,1.3l-6.1,5.9   c-0.2,0.2-0.3,0.4-0.2,0.7l1.4,8.4c0.1,0.6-0.5,1.1-1.1,0.8l-7.5-4c-0.2-0.1-0.5-0.1-0.7,0l-7.5,4c-0.5,0.3-1.2-0.2-1.1-0.8   l1.4-8.4c0-0.2,0-0.5-0.2-0.7L46.1,47c-0.4-0.4-0.2-1.2,0.4-1.3l8.4-1.2c0.2,0,0.4-0.2,0.6-0.4l3.8-7.6   C59.6,35.9,60.3,35.9,60.6,36.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrp);
export default __webpack_public_path__ + "static/media/trp.f06dfb341fab5755541d1a79cc8f0540.svg";
export { ForwardRef as ReactComponent };